import React, { useState, useEffect } from 'react';
import { prepareData } from 'utils/googleData'
import GithubSlugger from 'github-slugger'
export  function AppsDocumentation(props) {
    const slugger = new GithubSlugger()

    const {
        enable,
        title,
        subtitle,
        video,
        description,
        cta,
        cards,
        direction,
        style,
        gatsbyImage,
        features,
        gatsbyTransformed,
        documentation,
        headings
    } = prepareData({ props })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    if (!Array.isArray(documentation?.headings) ) {
        return <></>
    }
  return (

        <>
        <h4 className="mt-6 mb-2">{title} documentation</h4>
            <ul className="m-0 p-0 list-none">
                {documentation?.headings?.map((heading) => {
                    const id = slugger?.slug(heading?.value)
                    return (
                        <li key={id}>
                            <Link
                                className="text-[18px] group font-semibold pb-3 mb-3 border-b border-dashed border-gray-accent-light dark:border-gray-accent-dark flex justify-between items-center"
                                to={`${documentation?.fields?.slug}#${id}`}
                            >
                                <span>{heading?.value}</span>
                                <RightArrow className="w-6 h-6 text-gray bounce" />
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </>
    )
}

export default AppsDocumentation
